
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { TTaskSelect } from "@/models/expert_tasks";
import { SMCases } from "@/store";
import { ASK_POPUP_TYPE } from "@/constants/popupTypes";

@Component
export default class MoveToStepPopUp extends Vue {
  @Prop({ type: Boolean, default: false }) readonly moveToStepPopup!: boolean;
  @Prop({ type: String, default: ASK_POPUP_TYPE }) readonly type!: string;
  @Prop({ type: Array, default: () => [] }) readonly progressSteps!: TTaskSelect[];

  showPopup = false;

  // TODO: Refactor it, after refactoring "Nb-dialog" component;
  @Watch("moveToStepPopup", { immediate: true })
  createTaskPopupChanged(val: boolean) {
    this.showPopup = val;
  }

  open() {
    this.showPopup = true;
  }

  caseProgressStepId: number | null = null;

  get serviceId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  closeStepPopup() {
    this.showPopup = false;

    this.caseProgressStepId = null;

    this.$emit("close");
  }

  loading = false;

  async moveToStep() {
    try {
      this.loading = true;

      const { caseProgressStepId } = this;

      if (!caseProgressStepId) return;

      await this.axios.get(API_ROUTES.CASE_MOVE_TO_STEP(this.serviceId, caseProgressStepId));

      const stepName = this.progressSteps.find((item) => item.value === caseProgressStepId)?.label;

      if (stepName) SMCases.setCaseStepName(stepName);

      this.$emit("update");

      this.closeStepPopup();
    } finally {
      this.loading = false;
    }
  }
}
